module.exports = __webpack_public_path__ + "img/conduk.3a8b280a.png";